import { render, staticRenderFns } from "./PromotionVariableForm.vue?vue&type=template&id=6109b456"
import script from "./PromotionVariableForm.vue?vue&type=script&lang=js"
export * from "./PromotionVariableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports